module.exports = __webpack_public_path__ + "static/img/m_role.303e161.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/wxsjglm/m_role.png
// module id = zy86
// module chunks = 7